<div class="alert alert-{{type}} {{#if dismissable}}alert-dismissible{{/if}} fade show" role="alert">
  {{#if title}}
    <strong>{{{title}}}</strong>
  {{/if}}
  {{{text}}}
  {{#if dismissable}}
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
  {{/if}}
</div>